// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

function cutDownTime() {
  let nowTime = new Date();
  let endTime = new Date(endTimeG);

  let leftTime = endTime.getTime() - nowTime.getTime();
  if (leftTime < 0) {
    setupNewCountdown();
    leftTime = 0;
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60);
  leftH = leftH >= 10 ? leftH : "0" + leftH;
  leftM = leftM >= 10 ? leftM : "0" + leftM;
  leftS = leftS >= 10 ? leftS : "0" + leftS;

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  };
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9);
  const currentTime = new Date();
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
  setupNewCountdown();
  if (intervalId) clearInterval(intervalId);
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime();
    $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
    $(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
    $(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
  }, 1000);
}

getCutDownTime();

function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
      config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  };

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    new Swiper(".sp-swiper1", {
      autoplay: {
        disableOnInteraction: false,
        delay: 2500,
      },
      spaceBetween: 0,
      slidesPerView: "auto",
      centeredSlides: true,
      loop: true,
    });

    new Swiper(".sp-swiper2", {
      autoplay: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      slideShadows: true,
      slidesPerView: "auto",
      spaceBetween: 0,
      centeredSlides: true,
      loop: true,
      pagination: {
        el: ".sp-pagination",
        clickable: true,
      },
    });

    new Swiper(".sp-swiper3", {
      autoplay: {
        disableOnInteraction: false,
        delay: 2500,
      },
      spaceBetween: 0,
      slidesPerView: "auto",
      centeredSlides: true,
      loop: true,
      pagination: {
        el: ".sp-pagination",
        clickable: true,
      },
    });

    // $(".reduce").click(function () {
    //   let input = $(this).siblings("input")[0];
    //   let num = Number(input.value) - 1;
    //   if (num > 0) {
    //     input.value = num;
    //     $(this).parent().siblings(".price-group").find(".price1 span").html( ((18.99 * num).toFixed(2) + '') )
    //     $(this).parent().siblings(".price-group").find(".price2 span").html( ((49.99 * num).toFixed(2) + '') )
    //   }
    // });
    // $(".add").click(function () {
    //   let input = $(this).siblings("input")[0];
    //   let num = Number(input.value) + 1;
    //   input.value = num;
    //   $(this).parent().siblings(".price-group").find(".price1 span").html( ((18.99 * num).toFixed(2) + '') )
    //   $(this).parent().siblings(".price-group").find(".price2 span").html( ((49.99 * num).toFixed(2) + '') )
    // });

    // ==================== 辅助函数 ====================
// 获取当前货币汇率
function getCurrencyRate() {
  try {
    const { currencyActiveInfo = {}, currencyCurrent = "" } = window._transcy || {};
    return currencyActiveInfo?.detail?.convert[currencyCurrent] || 1;
  } catch (e) {
    return 1;
  }
}

// 根据 variantId 获取原始价格（单位：分 → 元）
function getVariantPriceById(variantId) {
  const variant = window.product.find(v => v.id == variantId);
  if (!variant) return { price: 0, comparePrice: 0 };
  
  let price = variant.price;
  let comparePrice = variant.compare_at_price;
  
  // 如果价格是整数且大于100（说明单位是分），转为元
  if (price > 100 && Number.isInteger(price)) price = price / 100000;
  if (comparePrice > 100 && Number.isInteger(comparePrice)) comparePrice = comparePrice / 100000;
  
  return { price, comparePrice };
}

// 更新单个产品盒子的价格显示
function updateProductPrice($box) {
  const $input = $box.find('.input_number');
  let quantity = parseInt($input.val()) || 1;
  quantity = Math.max(1, Math.min(200, quantity)); // 限制范围
  
  const variantId = $box.find('.sp-btn-style').data('id');
  if (!variantId) return;
  
  const { price: basePrice, comparePrice: baseComparePrice } = getVariantPriceById(variantId);
  const rate = getCurrencyRate();
  
  // 计算总价（当前货币）
  const totalPrice = (basePrice * quantity * rate).toFixed(3);
  const totalComparePrice = (baseComparePrice * quantity * rate).toFixed(3);
  
  // 更新价格显示（保留原货币符号）
  const $price1 = $box.find('.price1');
  const $price2 = $box.find('.price2');
  
  if ($price1.length) {
    const price1Text = $price1.text();
    const newPrice1Text = price1Text.replace(/\d+(?:[.,]\d+)*/g, totalPrice);
    $price1.html(newPrice1Text);
  }
  
  if ($price2.length) {
    const price2Text = $price2.text();
    const newPrice2Text = price2Text.replace(/\d+(?:[.,]\d+)*/g, totalComparePrice);
    $price2.html(newPrice2Text);
  }
}

// 初始化所有产品价格（适配 transcy 汇率）
function initAllProductPrices() {
  $('.product-box').each(function() {
    updateProductPrice($(this));
  });
}

// ==================== 绑定事件 ====================
// 减数量按钮
$('.reduce').off('click').on('click', function() {
  const $box = $(this).closest('.product-box');
  const $input = $box.find('.input_number');
  let num = parseInt($input.val()) || 1;
  if (num > 1) {
    num--;
    $input.val(num);
    updateProductPrice($box);
  }
});

// 加数量按钮
$('.add').off('click').on('click', function() {
  const $box = $(this).closest('.product-box');
  const $input = $box.find('.input_number');
  let num = parseInt($input.val()) || 1;
  if (num < 200) {
    num++;
    $input.val(num);
    updateProductPrice($box);
  }
});

// 手动输入数量变化
$('.input_number').off('change').on('change', function() {
  const $box = $(this).closest('.product-box');
  let num = parseInt($(this).val()) || 1;
  num = Math.max(1, Math.min(200, num));
  $(this).val(num);
  updateProductPrice($box);
});

// 页面加载后立即执行一次价格更新（适配 transcy）
initAllProductPrices();

// 监听 transcy 切换货币后重新计算价格（可选）
if (window._transcy) {
  $(document).on('transcy:currencyChanged', function() {
    initAllProductPrices();
  });
} else {
  // 如果 transcy 异步加载，延迟重试一次
  setTimeout(initAllProductPrices, 500);
}

    $(".sp-univalent div").click(function () {
      $(this).addClass("active").siblings().removeClass("active");
      let index = $(this).index();
      $('.img-wrap2 img').attr('src', 'https://cdn.shopify.com/s/files/1/0624/7687/7889/files/20250703-p' + (index + 3) + '.png');
    });
    $('.sp-btn-style').click(function () {
      let id = ''
      let num = 1
      const index = $(this).data("index")
      if (index) {
        id = $(this).siblings(".sp-univalent").find(".active").data("id")
      }else {
        id = $(this).data("id")
        num = $(this).siblings(".addGroup").find(".input_number").val()
      }
      window.location.href = '/cart/' + id + ':' + num
    })
    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top: offsetTop * $("div#root").css("zoom") - 240 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }



  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");
    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade2 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }




}

mainRender();